<template>
  <div>
    <div
      class="py-2 py-md-0 header-color"
      :style="{
        background: $route.path.includes('searchpage') || $route.path.includes('circles') || $route.path.includes('contact-us') ? '#2a71d4' : getPrimaryColor(),
      }"
    >
      <div class="dovemed-wrapper header-wrapper d-flex justify-content-between">
        <!-- <a-icon @click="showMenuL" class="ham-icon" type="bars" /> -->
        <!-- <div
          class="d-flex justify-content-between align-items-center mr-auto mr-md-0"
        >
          <router-link
            :to="'/circles'"
            class="nav-link-blue mr-2"
            data-toggle="pill"
            role="tab"
            aria-controls="pills-profile"
            aria-selected="false"
          >
            <img class="logo" src="../../assets/dovemed-logo.svg" alt />
          </router-link>
        </div> -->
        <div class="d-flex align-items-center header-logo">
          <img @click="goToHome" class="logo mr-3" :src="getCircleLogo()" alt="logo" />
          <!-- :src="currentCircle.url ? currentCircle.url : defaultCircleLogo" -->
          <!-- <div class="beta" :style="{ color: '#2a71d4' }">
            <div class="beta-version">
              Beta
            </div>
          </div> -->
          <!-- <h6 class="logo-condition">{{ currentCircle.condition_type }}</h6> -->
        </div>

        <div class="left-sidebar d-sm-none" ref="closeHam">
          <div class="close" @click="hideL">X</div>
          <ul class="navigator">
            <li class="font-weight-bold" @click="hideL">
              <router-link :to="'/circles'" class="nav-link-blue" data-toggle="pill" role="tab" aria-controls="pills-profile" aria-selected="false"> Home </router-link>
            </li>
            <!-- <li class="font-weight-bold">ABOUT</li> -->
            <!-- <li class="font-weight-bold" @click="hideL">
            <router-link
              :to="''"
              class="nav-link-blue"
              data-toggle="pill"
              role="tab"
              aria-controls="pills-profile"
              aria-selected="false"
              >PARTNERSHIPS</router-link
            >
            </li> -->
            <!-- <li class="font-weight-bold" @click="hideL">
            <router-link
              :to="{ name: 'ContactUs' }"
              class="nav-link-blue"
              data-toggle="pill"
              role="tab"
              aria-controls="pills-profile"
              aria-selected="false"
              >CONTACT</router-link
            >
          </li> -->

            <!-- <li
              v-if="!authUser"
              class="font-weight-bold"
              @click="$router.push('/login')"
            >
              <a @click="hideL"> LOGIN</a>
            </li> -->
          </ul>
        </div>
        <div v-if="authUser" class="d-sm-none">
          <!-- <a-dropdown :trigger="['click']">
            <font-awesome-icon
              size="2x"
              :style="{
                color: '#0e72ba',
                transform: 'scale(0.8)'
              }"
              :icon="['fas', 'user']"
            />
          </a-dropdown> -->
          <!-- <a-dropdown :trigger="['click']">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <font-awesome-icon
                size="2x"
                :style="{
                  color: '#ffffff',
                  transform: 'scale(0.8)'
                }"
                :icon="['fas', 'user']"
              />
            </a>
            <a-menu slot="overlay">
              <a-menu-item key="0">
                <span> {{ authUser.user.email }}</span>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </div>
        <!-- <div
          v-if="authUser"
          class="font-weight-bold text-danger d-sm-none"
          @click="logout"
        >
          <div @click="hideL">
            <font-awesome-icon
              size="2x"
              :style="{
                color: 'red',
                transform: 'scale(0.8)',
                'margin-left': '10px'
              }"
              :icon="['far', 'power-off']"
            />
          </div>
        </div> -->

        <!-- for small screens -->
        <!-- <div v-if="authUser" class="ml-2 d-sm-none"> -->
        <div v-if="authUser" class="ml-2 d-none">
          <!-- <a-dropdown :trigger="['click']">
            <font-awesome-icon
              size="2x"
              :style="{
                color: '#0e72ba',
                transform: 'scale(0.8)'
              }"
              :icon="['fas', 'user']"
            />
          </a-dropdown> -->
          <a-dropdown :trigger="['click']">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()" href="#">
              <a-avatar
                :style="{
                  color: ' #ffffff !important',
                  'background-color': authUser.user ? getAvatarColor(authUser.user.id) : '#EF8585',
                  border: '1px solid #F8FAFD',
                }"
                class="text-capitalize"
                alt="avatar"
              >
                {{ authUser.user.firstName ? authUser.user.firstName[0] : authUser.user.display_name ? authUser.user.display_name[0] : "D" }}
              </a-avatar>
            </a>
            <a-menu slot="overlay" class="mt-3">
              <a-menu-item key="0">
                <span> {{ authUser.user.email }} </span>
              </a-menu-item>
              <a-menu-item key="1">
                <span @click="handleLogout"> LOGOUT</span>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
        <div v-if="!authUser" @click="() => goToSSO()" class="fw700 py-2 px-3 br6 d-md-none text-white bg-gray900 font12">Get Started</div>
        <!-- <div v-if="!authUser" @click="ssoLogin" class="fw700 py-2 px-3 br6 d-md-none text-white bg-gray900 font12">Get Started</div> -->

        <!-- for big screens -->
        <!-- <ul class="navigator d-none d-sm-block"> -->
        <ul :class="`navigator res-nav ${authUser ? '' : 'hide-in-mobile'}`">
          <li :class="`fw700 hide-in-mobile ${$route.path === '/circles/all' ? 'active-link' : ''}`">
            <!-- :class="
              this.$route.path === '/circles/all'
                ? 'font-weight-bold active-link hide-in-mobile'
                : 'font-weight-bold hide-in-mobile'
            " -->
            <div @click="$router.push({ path: '/circles' })" data-toggle="pill" role="tab" aria-controls="pills-profile" aria-selected="false" :style="{ color: '#ffffff !important ' }">Home</div>
          </li>
          <!-- <li class="font-weight-bold">ABOUT</li> -->
          <!-- <li class="font-weight-bold">
            <router-link
              :to="{ name: 'ContactUs' }"
              class="nav-link-blue"
              data-toggle="pill"
              role="tab"
              aria-controls="pills-profile"
              aria-selected="false"
              >PARTNERSHIPS
              </router-link>
          </li> -->
          <!-- <li class="font-weight-bold">
            <router-link
              :to="{ name: 'ContactUs' }"
              class="nav-link-blue"
              data-toggle="pill"
              role="tab"
              aria-controls="pills-profile"
              aria-selected="false"
              >CONTACT</router-link
            >
          </li> -->

          <!-- :class="
              this.$route.path === '/searchpage/default/all' ||
              this.$route.path === '/searchpage/joinedcircle' ||
              this.$route.path === '/searchpage/unauthcircle'
                ? 'font-weight-bold active-link'
                : 'font-weight-bold'
            "
            v-if="$route.path.includes('circles')" -->
          <li
            :class="
              `fw700 ${this.$route.path === '/searchpage/default/all' || this.$route.path === '/searchpage/joinedcircle' || this.$route.path === '/searchpage/unauthcircle' ? 'active-link' : ''} ${
                $route.path.includes('circles') ? '' : 'hide-in-mobile'
              }`
            "
          >
            <div
              data-toggle="pill"
              role="tab"
              aria-controls="pills-profile"
              aria-selected="false"
              :style="{ color: '#ffffff !important ' }"
              @click="handleGoToSearchPage"
              :class="`${authUser ? 'myC' : ''}`"
            >
              {{ !authUser ? "Search" : "My Circles" }}
            </div>
            <!-- <router-link to="/searchpage/" active-class="font-weight-bold" exact>
              Search
            </router-link> -->
          </li>
          <li v-if="authUser" :class="`font-weight-bold text-danger pl-0  ${$route.path.includes('circles') ? 'hide-in-mobile' : ''}`">
            <div v-if="authUser" class="ml-2">
              <a-dropdown :trigger="['click']" class="header-profile-pop" :overlayClassName="'header-profile-pop-overlay'">
                <a class="ant-dropdown-link" @click="e => e.preventDefault()" href="#">
                  <a-avatar
                    :style="{ color: ' #ffffff !important', 'background-color': authUser.user ? getAvatarColor(authUser.user.id) : '#EF8585', border: '1px solid #F8FAFD' }"
                    class="avatar-border"
                    :size="40"
                    alt="avatar"
                  >
                    {{ getInitials }}
                  </a-avatar>
                </a>
                <a-menu slot="overlay" class="mt-3">
                  <a-menu-item key="0" class="header-profile-pop-list">
                    <div class="d-flex align-items-center mw343 mt15">
                      <div class="flex-center-center hw70 rounded-circle fw700 font24 text-white" :style="{ border: '1px solid #F8FAFD', background: getAvatarColor(authUser.user.id) }">
                        {{ getInitials }}
                      </div>
                      <p class="mb-0 ml-3 fw700 font18 text-black">
                        {{ authUser.user.email || authUser.user.first_name || authUser.user.display_name || "D" }}
                      </p>
                    </div>
                    <button class="w-100 fw700 bg-gray200 br6 p1224 mt-4 flex-center-center mw343" :style="{ border: 'none', color: getPrimaryColor() }" @click="$router.push({ path: '/searchpage' })">
                      View all my Circles
                      <font-awesome-icon :icon="['far', 'arrow-right']" class="font20 ml-auto" :style="{ color: getPrimaryColor() }" />
                    </button>
                    <button class="w-100 fw700 br6 mt-4 p1224 text-white d-block mw343" :style="{ border: 'none', background: getSecondaryColor() }" @click="handleLogout">Logout</button>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </li>
          <!-- <li
            v-if="!authUser"
            class="font-weight-bold"
            @click="$router.push('/circles/all')"
          >
            <a @click="hideL"> LOGIN</a>
          </li> -->
          <!-- Below is the correct one -->
          <!-- <li
            v-if="!authUser"
            :style="{ color: '#ffffff' }"
            class="font-weight-bold"
            @click="ssoLogin"
          >
            <div
              @click="hideL"
              :style="{
                padding: '12px 24px',
                background: 'rgba(255, 255, 255, 0.152)',
                'border-radius': '8px'
              }"
            >
              LOGIN
            </div>
          </li> -->
          <li :style="{ color: '#ffffff' }" class="font-weight-bold" @click="() => goToSSO()" v-if="!authUser">
            <!-- <li :style="{ color: '#ffffff' }" class="font-weight-bold" @click="ssoLogin" v-if="!authUser"> -->
            <div :style="{ padding: '12px 24px', background: '#062B54', 'border-radius': '8px' }">
              Get Started
            </div>
          </li>
        </ul>
      </div>
      <div v-if="logoutProcess" class="spinnerContainer">
        <a-spin size="large" />
      </div>
    </div>
    <!-- <SSOModal ref="modal" /> -->
  </div>
</template>

<script>
import "../../../src/assets/css/antd-dovemed.min.css"
import "../../../src/assets/css/custom.scss"
// import SSOLogin from "../login/login-register-component"
// import SSOModal from "../login/login-register-modal"
import { mapGetters } from "vuex"

export default {
  name: "HeaderGeneric",
  data() {
    return {
      activeLink: "Home",
      // userData: {},
      logoutProcess: false,
      defaultCircleLogo: null,
    }
  },
  watch: {
    activeLink: function(old, newVal) {
      this.activeLink = newVal
    },
  },
  computed: {
    ...mapGetters({
      activeLink: "Hello",
    }),
    getInitials() {
      const f = this.authUser.user.email
        ? this.authUser.user.email[0].toUpperCase()
        : this.authUser.user.first_name
        ? this.authUser.user.first_name[0].toUpperCase()
        : this.authUser.user.display_name
        ? this.authUser.user.display_name[0].toUpperCase()
        : "D"
      return f
    },
  },
  mounted() {
    console.log("(mounted) HeaderGeneric.vue -> authUser", this.authUser)
    this.activeLink = "Home"
  },

  created() {
    console.warn('HeaderGeneric.vue is created');
    if (this.$el && this.$el.querySelector("#app").classList.contains("no-scroll")) {
      document.querySelector("#app").classList.remove("no-scroll")
    }
    this.defaultCircleLogo = require("../../assets/dovemed-logo.svg")
  },

  // components: {
  //   SSOLogin,
  //   SSOModal,
  // },

  methods: {
    goToSSO() {
      const currentPath = encodeURIComponent(window.location.href)
      window.location.href = `${process.env.SSO_BASE_URL}/dovemed-sso?next=${this.$route.path.includes("circleInfo") ? currentPath : `${process.env.SSO_BASE_URL}/mycircles`}`
    },
    getCircleLogo() {
      if (this.$route.path.includes("searchpage") || this.$route.path.includes("circles") || this.$route.path.includes("contact-us")) {
        return this.defaultCircleLogo
      } else {
        return this.currentCircle.url ? this.currentCircle.url : this.defaultCircleLogo
      }
    },
    handleLogout() {
      this.logoutProcess = true
      this.logout()
      this.$router.push({
        path: "/circles",
      })
      this.logoutProcess = false
    },
    // ssoLogin() {
    //   console.log("HeaderGeneric -> ssoLogin")
    //   document.body.scrollTop = 0
    //   this.$store.commit("SsoLogin/openModal")
    //   if (this.$route.path.includes("searchpage") || this.$route.path.includes("circleInfo")) {
    //     this.$refs.modal.open()
    //   }
    // },
    hideL() {
      if (this.$el.querySelector(".left-sidebar").classList.contains("left-sidebar-show")) {
        this.$el.querySelector(".left-sidebar").classList.remove("left-sidebar-show")
      }
      this.$el.querySelector(".left-sidebar").classList.add("left-sidebar-hide")
      document.querySelector("#app").classList.remove("no-scroll")
    },
    // showMenuL() {
    //   if (document.querySelector(".left-sidebar").classList.contains("left-sidebar-hide")) {
    //     document.querySelector(".left-sidebar").classList.remove("left-sidebar-hide")
    //   }
    //   document.querySelector(".left-sidebar").classList.add("left-sidebar-show")
    //   document.querySelector("#app").classList.add("no-scroll")
    // },
    goToHome() {
      this.$router.push({ path: "/" }).catch(err => {})
    },
    handleGoToSearchPage() {
      if (this.authUser) {
        this.$router.push({ path: "/searchpage" }).catch(err => {})
      } else {
        this.$router.push({ path: "/searchpage/default/all" }).catch(err => {})
      }
      this.activeLink = "Search"
      // this.$router.push({ path: "/searchpage" }).catch(err => {});
    },
  },
}
</script>

<style lang="scss" scoped>
.active-link {
  background: #3f7fd8;
  color: #fff;
}
.nav-link-blue {
  color: #ffffff;
}
.nav-link-blue.router-link-active {
  color: #ffffff !important;

  @media screen and (max-width: 1200px) {
    color: #0e72ba !important;
  }

  @media screen and (max-width: 900px) {
    color: #0e72ba !important;
  }

  @media screen and (max-width: 600px) {
    color: #0e72ba !important;
  }
}

.dovemed-header {
  height: 60px;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.header-wrapper {
  max-width: 1200px;
  // padding: 0 90px;
}

.logo {
  height: 30px;
  width: 159px;
  align-self: center;
  object-fit: contain;
}

.navigator {
  list-style-type: none;
  margin-bottom: 0;

  li {
    color: #fff;
    font-size: 14px;
    display: inline-block;
    // text-transform: uppercase;
    padding: 12px 24px;
    border-radius: 6px;
    cursor: pointer;
    @media screen and (max-width: 580px) {
      display: block;
      font-size: 14px !important;
      // padding: 8px;
    }
    a {
      color: #ffffff !important;
    }
  }

  .dropdown-btn-class {
    color: #fff;
    font-size: 14px;
    text-transform: uppercase;
    cursor: pointer;
  }
}
.header-color {
  background: #2a71d4;
  // box-shadow: 5px 10px #888888;
  z-index: 10;
  position: sticky;
  top: 0;
  box-shadow: 0 0 5px #333;
  @media screen and (max-width: 600px) {
    box-shadow: none;
    filter: drop-shadow(0px 0px 9px rgba(0, 0, 0, 0.1));
    padding: 16px !important;
  }
}
.header-logo {
  .logo {
    margin-top: 0px;
  }
  @media screen and (max-width: 900px) {
    display: flex;
    flex-direction: column-reverse;
    .beta {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-right: 30px;

      &-version {
        padding: 2px 4px;
        font-size: 8px;
        line-height: 8px;
        margin-bottom: 4px;
      }
    }
  }
}
.spinnerContainer {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.5);
  z-index: 999;
}
.res-nav {
  @media screen and (max-width: 600px) {
    display: flex;
    align-items: center;
    padding-left: 0 !important;
    li:nth-child(2) {
      padding: 10px !important;
    }
  }
}
@media screen and (max-width: 768px) {
  .myC {
    background: rgba(255, 255, 255, 0.15);
    padding: 8px 16px;
    border-radius: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App/HeaderGeneric.vue